import * as angular from 'angular';

import { GuidObjectType } from '../../models/enum';
import { IRequestService } from '../request.service';
import { CustomReplacementDictionary } from '../../models';

export interface ICustomPropertiesService {
    getCustomProperties(guid: string, type: GuidObjectType): angular.IPromise<CustomReplacementDictionary>;
    cleanCache(): void;
}

export class CustomPropertiesService implements ICustomPropertiesService {

    static serviceId = 'customPropertiesService';
    static $inject = ['requestService'];

    private _cachedUrl = {};

    constructor(private _requestService: IRequestService) {

    }

    getCustomProperties(guid: string, type: GuidObjectType): angular.IPromise<CustomReplacementDictionary> {
        const url = this.getUrl(guid, type);
        return this._requestService.getAtV1(url).then(data => {
            this._cachedUrl[url] = true;
            return data;
        }) as any;
    }

    cleanCache(): void {
        this._requestService.cleanCacheAtV1('customProperties');
        this._requestService.cleanCacheAtV1('customProperties/inherited');
        Object.keys(this._cachedUrl).forEach(url => {
            this._requestService.cleanCacheAtV1(url);
        });
        this._cachedUrl = {};
    }

    private getUrl(guid: string, type: GuidObjectType) {
        return `customProperties/inherited?guid=${guid}&type=${type}`;
    }
}